import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoiceOpened = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 12,
	viewBox: "0 0 15 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .7,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M14.32 5.40971L13.8581 5.60116L14.32 5.40971ZM14.32 6.5903L13.8581 6.39884L14.32 6.5903ZM1.11744 6.59029L0.655542 6.78174L1.11744 6.59029ZM1.57933 5.60116C2.57765 3.19265 4.9511 1.5 7.71872 1.5V0.5C4.53278 0.5 1.80329 2.44924 0.655542 5.21825L1.57933 5.60116ZM7.71872 1.5C10.4863 1.5 12.8598 3.19266 13.8581 5.60116L14.7819 5.21826C13.6342 2.44925 10.9047 0.5 7.71872 0.5V1.5ZM13.8581 6.39884C12.8598 8.80735 10.4863 10.5 7.71872 10.5V11.5C10.9047 11.5 13.6342 9.55076 14.7819 6.78175L13.8581 6.39884ZM7.71872 10.5C4.9511 10.5 2.57765 8.80735 1.57933 6.39884L0.655542 6.78174C1.80328 9.55075 4.53278 11.5 7.71872 11.5V10.5ZM13.8581 5.60116C13.9639 5.85635 13.9639 6.14366 13.8581 6.39884L14.7819 6.78175C14.9893 6.28141 14.9893 5.7186 14.7819 5.21826L13.8581 5.60116ZM0.655542 5.21825C0.448153 5.7186 0.448152 6.2814 0.655542 6.78174L1.57933 6.39884C1.47356 6.14366 1.47356 5.85634 1.57933 5.60116L0.655542 5.21825Z",
			fill: "#85A0AD"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 7.71903,
			cy: 5.99979,
			r: 2.14286,
			stroke: "#85A0AD",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgInvoiceOpened;
